import { motion } from "framer-motion";

const SPECS = [
  { k: "Build", v: "FLAT-PACK KIT, UP IN 3 DAYS" },
  { k: "Kitchen", v: "2 FRYERS + 1 TAWA" },
  { k: "Service", v: "90-SECOND HANDOVER" },
  { k: "Signature scent", v: "FRIED CURRY LEAF, ALWAYS" },
];

export const Stall = () => (
  <section id="stall" data-testid="stall-section" className="border-y-4 border-kadak bg-taxi py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 sm:px-6 lg:grid-cols-2">
      <div>
        <p className="font-bungee text-xs tracking-[0.35em] text-mirchi sm:text-sm">THE STALL</p>
        <h2 className="mt-4 font-shrikhand text-4xl leading-tight text-kadak sm:text-5xl lg:text-6xl">
          80 sq ft of pure theatre
        </h2>
        <p className="mt-5 max-w-md text-base text-kadak/75">
          Marquee bulbs, taxi checker, a chai counter and one hero dish on display — the flagship "Khoka"
          is designed to be photographed.
        </p>
        <div className="mt-8 space-y-0 border-t-2 border-dashed border-kadak/40">
          {SPECS.map((s) => (
            <div key={s.k} className="flex items-baseline justify-between gap-4 border-b-2 border-dashed border-kadak/40 py-4">
              <span className="text-sm text-kadak/70">{s.k}</span>
              <span className="text-right font-anton text-base uppercase text-kadak sm:text-lg">{s.v}</span>
            </div>
          ))}
        </div>
      </div>
      <motion.div
        initial={{ opacity: 0, rotate: 4, y: 30 }}
        whileInView={{ opacity: 1, rotate: 2, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ type: "spring", stiffness: 70, damping: 14 }}
        className="rounded-3xl border-4 border-kadak bg-kadak p-6 sticker-shadow sm:p-8"
      >
        <div className="flex justify-center gap-2">
          {Array.from({ length: 12 }).map((_, i) => (
            <span key={i} className={`h-3 w-3 rounded-full ${i % 3 === 0 ? "bg-taxi" : i % 3 === 1 ? "bg-gulabi" : "bg-chutney"}`} />
          ))}
        </div>
        <div className="mt-5 rounded-2xl border-4 border-taxi bg-kadak px-6 py-5 text-center">
          <p className="font-shrikhand text-4xl text-taxi" style={{ textShadow: "3px 3px 0 #E03A2F" }}>
            VADA SUB
          </p>
          <p className="mt-1 font-bungee text-[10px] tracking-[0.4em] text-pav">STREET ICON, UNCURLED</p>
        </div>
        <div className="mt-5 grid grid-cols-2 gap-3">
          <div className="rounded-xl border-2 border-pav/40 p-4">
            <p className="font-shrikhand text-lg text-taxi">Menu</p>
            <div className="mt-2 space-y-1.5 text-xs text-pav/80">
              <div className="flex justify-between"><span>OG BOMBAY</span><span className="text-taxi">79</span></div>
              <div className="flex justify-between"><span>TRIDEV</span><span className="text-taxi">179</span></div>
              <div className="flex justify-between"><span>CHEESE BARBAAD</span><span className="text-taxi">109</span></div>
            </div>
          </div>
          <div className="flex flex-col gap-3">
            <div className="flex-1 rounded-xl border-2 border-gulabi bg-gulabi/20 p-4 text-center">
              <p className="font-shrikhand text-xl text-gulabi">GARMA GARAM</p>
            </div>
            <div className="rounded-xl bg-taxi p-3 text-center font-bungee text-xs text-kadak">HORN OK PAV</div>
          </div>
        </div>
        <div className="tape-checker mt-5 h-5 w-full rounded-md" />
      </motion.div>
    </div>
  </section>
);
